import React, { useState, useEffect } from "react";
import { Table, Button } from "react-bootstrap";
import { ApiGet } from "../../../service/ApiService";
import { formatDate } from "../../../service/DateUtils";

// Extracted row component which fetches assigned roles for each user.
const UserRow = ({ user, rolesRefresh, onEdit, onResetPassword, onManageRoles, onDelete }) => {
  const [assignedRoles, setAssignedRoles] = useState([]);

  useEffect(() => {
    ApiGet(
      `/api/user/role/assigned/${user.id}`,
      (data) => {
        setAssignedRoles(data || []);
      },
      (err) => {
        // For simplicity, we log the error and clear roles.
        console.error(err);
        setAssignedRoles([]);
      }
    );
  }, [user.id, rolesRefresh]); // re-fetch when rolesRefresh changes

  return (
    <tr key={user.id}>
      <td>{user.id}</td>
      <td>{user.tenant.name}</td>
      <td><strong>{user.email}</strong></td>
      <td>{formatDate(user.createdAt)}</td>
      <td>{formatDate(user.updatedAt)}</td>
      <td>{assignedRoles.join(", ")}</td>
      <td>
        {user.id > 1 && (
          <>
            <Button variant="warning" className="me-2" onClick={() => onEdit(user)}>
              Edit
            </Button>
            <Button variant="info" className="me-2" onClick={() => onResetPassword(user)}>
              Reset password
            </Button>
            <Button variant="secondary" className="me-2" onClick={() => onManageRoles(user)}>
              Manage Roles
            </Button>
            <Button variant="danger" onClick={() => onDelete(user.id)}>
              Delete
            </Button>
          </>
        )}
      </td>
    </tr>
  );
};

const UsersTable = ({ tenants, users, rolesRefresh, onEdit, onResetPassword, onManageRoles, onDelete }) => {
  return (
    <>
      {tenants.map(tenant => (
        <div key={`tenant-${tenant.id}`}>
          <div
            className="mt-3 mb-2 d-flex justify-content-between align-items-center"
            style={{ borderBottom: "1px solid #ccc" }}
          >
            <h4 className="mb-0">{tenant.name}</h4>
            <p className="text-muted mb-0">{tenant.description}</p>
          </div>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Tenant</th>
                <th>Email</th>
                <th>Created</th>
                <th>Updated</th>
                <th>Roluri</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users
                .filter(user => user.tenant.id === tenant.id)
                .map(user => (
                  <UserRow
                    key={user.id}
                    user={user}
                    rolesRefresh={rolesRefresh}
                    onEdit={onEdit}
                    onResetPassword={onResetPassword}
                    onManageRoles={onManageRoles}
                    onDelete={onDelete}
                  />
              ))}
            </tbody>
          </Table>
        </div>
      ))}
    </>
  );
};

export default UsersTable;